<script setup lang="ts">

import { onMounted, onUnmounted } from "vue";
import { DefaultSections, usePresentation } from "@presentation/Types";

import PageDots from "./PageDots.vue";

const presentation = usePresentation();

const onKeyPress = ( e: KeyboardEvent ) => 
{
    if( [ 'PageDown', 'ArrowRight', 'ArrowDown', 'Space' ].includes( e.code ) ) presentation.next();
    if( [ 'PageUp', 'ArrowLeft', 'ArrowUp' ].includes( e.code ) ) presentation.back();
}

onMounted( () => window.addEventListener( 'keydown', onKeyPress ) );
onUnmounted( () => window.removeEventListener( 'keydown', onKeyPress ) );

</script>

<template>

    <div class="w-full grow flex flex-col items-center overflow-hidden">
        
        <!-- TRANSITION BETWEEN SECTIONS -->
        <transition mode="out-in"
            enter-active-class="transition ease-out duration-150"
            enter-from-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-150"
            leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95">

            <TabPanels 
                :key="presentation.currentSection.name"
                v-model="presentation.pageIndex"
                direction="vertical"
                grow
                class="!w-full !h-full
                       transform-gpu overflow-hidden" >

                <!-- ONE TAB PANEL FOR EACH PAGE IN THE SECTION -->
                <TabPanel 
                    v-for="(page, index) in presentation.currentSection.pages" 
                    class="!w-full !h-full overflow-y-auto">
                    <div class="w-full h-full flex flex-col items-center">
                        <Component 
                            v-if="presentation.pageIndex == index" 
                            :is="page.component" 
                        />
                    </div>
                </TabPanel>        

            </TabPanels>

        </transition>

        <!-- PAGE X OF Y DOTS -->
        <div v-if="[ DefaultSections.Start, DefaultSections.End ].includes( presentation.currentSection.name ) == false"
             class="absolute w-full bottom-[5.5rem] lg:w-auto lg:right-12 lg:bottom-7 flex justify-center">
            <PageDots 
                v-model="presentation.pageIndex"
                :count="presentation.currentSection.pages.length" 
                size="sm"
                class="mt-3 mb-2 top-[3px]" 
            />
        </div>

    </div>

</template>